import { DataResult } from '@/utils/mockUtils'

export default {
  getDataAnalysisList() {
    const data = [{
      "resourceId": 3366,    //资源主键
        "title": "初次部署",    // 名称
        "addTime": 12121312312, //上架时间
        "mpWeixinNumber":50, //从小程序端打开次数
        "webNumber":50, //从web端打开次数
        "createTime": 12621312312   //创建时间

    },
    {
      "resourceId": 33661,    //资源主键
        "title": "初次部署1",    // 名称
        "addTime": 12121312312, //上架时间
        "mpWeixinNumber":50, //从小程序端打开次数
        "webNumber":50, //从web端打开次数
        "createTime": 12421312312   //创建时间

    },
    {
      "resourceId": 33662,    //资源主键
        "title": "初次部署2",    // 名称
        "addTime": 12121312312, //上架时间
        "mpWeixinNumber":50, //从小程序端打开次数
        "webNumber":50, //从web端打开次数
        "createTime": 13121312312   //创建时间

    },
    {
      "resourceId": 33663,    //资源主键
        "title": "初次部署3",    // 名称
        "addTime": 12221312312, //上架时间
        "mpWeixinNumber":50, //从小程序端打开次数
        "webNumber":50, //从web端打开次数
        "createTime": 12121312312   //创建时间

    },
    {
      "resourceId": 33664,    //资源主键
        "title": "初次部署4",    // 名称
        "addTime": 12121312312, //上架时间
        "mpWeixinNumber":50, //从小程序端打开次数
        "webNumber":50, //从web端打开次数
        "createTime": 12121312312   //创建时间

    }
  ]
    return DataResult.getSuccessResponse({itemArr: data, total: 5})
  }
}